import { useMediaQuery } from 'usehooks-ts'
import Image from '~/components/Helpers/Image'
import MarkDown from '~/components/Helpers/MarkDown'
import TertiaryLink from '~/components/UI/Buttons/TertiaryLink/TertiaryLink'
import { cn } from '~/lib/utils'

interface PromoProps {
  title: string | null | undefined
  description: string | null | undefined
  img?: {
    asset?: { sys: { uri: string } } | undefined
    altText: string
  }
  link: { sys: { uri: string } } | undefined
}

const Promo = (props: PromoProps) => {
  const { title, description, img, link } = props

  const isMobile = useMediaQuery('(max-width: 1024px)', {
    defaultValue: true,
    initializeWithValue: false
  })

  const renderContent = (isDesktop = false) => (
    <div
      className={cn(
        'space-y-m',
        isDesktop
          ? 'p-s relative z-10 h-fit w-full justify-self-end text-white'
          : 'bg-blue-d p-xs-plus sm:p-l md:pr-2xl text-white'
      )}
    >
      <div className='space-y-xs'>
        {/* Title */}
        {title && (
          <div
            className='text-h3-sm sm:text-h3-md lg:text-h3-lg font-bold text-balance'
            role='heading'
            aria-level={3}
          >
            {title}
          </div>
        )}

        {/* Description */}
        {description && <MarkDown content={description} />}
      </div>

      {/* Link */}
      {link && (
        <div className='w-fit'>
          <TertiaryLink
            data={{
              externalLink: null,
              internalLink: link,
              ariaLabel: 'Find out more',
              newWindow: false,
              label: 'Find out more'
            }}
            colour='white'
          />
        </div>
      )}
    </div>
  )

  if (isMobile) {
    return renderContent()
  }

  return (
    <>
      <div className='relative z-10 flex h-full flex-col justify-end'>
        {img?.asset?.sys.uri && (
          <div className='absolute inset-0 z-0'>
            <Image image={{ asset: img.asset, altText: img.altText }} />
            <div className='absolute bottom-0 h-[300px] w-full bg-gradient-to-t from-black/90 to-black/0'></div>
          </div>
        )}

        {renderContent(true)}
      </div>
    </>
  )
}

export default Promo
